<div class="scroll-top" #scrolltop>
    <div class="scroll-top-div" #scrolltopdiv></div>
</div>

<div class='table-responsive' #tablewrapper>
    <table class="table table-striped table-sm table-hover" #table>
        <thead 
            class="thead-light"  
            app-datatable-th-lista 
            [id]="id"
            [datatable]="datatable"
            [sorts]="sorts"
            (onSortCambiados)="sortCambiados($event)">
        </thead>
        <tbody *ngIf="loading">
            <tr>
                <td [colSpan]="colspan()" class='text-center'>
                    <div class='big-height'>
                        <ngx-sync-loader></ngx-sync-loader>
                    </div>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="data.length == 0 && !loading">
            <tr>
                <td [colSpan]="colspan()" class='text-center'>No se han encontrado resultados.</td>
            </tr>
        </tbody>
        <ng-content select='.datatable-content' class='datatable-content'></ng-content>
    </table>
</div>